/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReportVibrationDaily { 
    date?: string;
    bearing_spindle?: number;
    vibration_level?: number;
    asset_health_indicator?: number;
    vibration_frame?: number;
    bearing_motor?: number;
    bearing_liquid_side?: number;
    bearing_solid_side?: number;
    motor_plate?: number;
}

